// Pravidlá hesla v aplikácii (rovnaké ako vo formulároch CreateUser / EditUser):
// aspoň 8 znakov, číslo, malé aj veľké písmeno a špeciálny znak z povolenej sady.
export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+=<>,.?/|\-])[a-zA-Z0-9!@#$%^&*()_+=<>,.?/|\-]{8,}$/;

// Bez zameniteľných znakov (0/O, 1/l/I) – heslo sa ľahšie prepíše alebo nadiktuje.
const LOWER = 'abcdefghijkmnpqrstuvwxyz';
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const DIGITS = '23456789';
const SPECIAL = '!@#$%&*+=?-_';   // podmnožina povolených znakov (bez < > | / , . kvôli čitateľnosti)

// Web Crypto má každý súčasný prehliadač (Windows, Android, iOS, macOS, Linux) – náhodu berie z OS.
// Ak chýba (veľmi starý prehliadač), generátor sa neponúkne; Math.random ako náhradu nepoužívame.
export const canGeneratePassword = () =>
  typeof globalThis.crypto !== 'undefined' && typeof globalThis.crypto.getRandomValues === 'function';

// Náhodné číslo 0..max-1 z crypto (funguje aj na http), bez modulo skreslenia
const randInt = (max) => {
  const buf = new Uint32Array(1);
  const limit = Math.floor(0x100000000 / max) * max;
  let x;
  do { crypto.getRandomValues(buf); x = buf[0]; } while (x >= limit);
  return x % max;
};
const pick = (set) => set[randInt(set.length)];

// Silné heslo, ktoré vždy spĺňa PASSWORD_REGEX (inak by sa ním nedalo prihlásiť / uložiť)
export function generatePassword(length = 14) {
  const all = LOWER + UPPER + DIGITS + SPECIAL;
  for (;;) {
    const chars = [pick(LOWER), pick(UPPER), pick(DIGITS), pick(SPECIAL), pick(SPECIAL)];
    while (chars.length < length) chars.push(pick(all));
    for (let i = chars.length - 1; i > 0; i--) {          // zamiešať (Fisher–Yates)
      const j = randInt(i + 1);
      [chars[i], chars[j]] = [chars[j], chars[i]];
    }
    const pwd = chars.join('');
    if (PASSWORD_REGEX.test(pwd)) return pwd;
  }
}
